import { PropertyConfig, PropertyOptions, PropertyOptionsList } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { keyof } from "@cervval.js/common/src/tools/object.tools";
import { I18nPayment } from "./payment.i18n";
import { PaymentProduct } from "./product.dto";

export enum ProductDataSourceUID {
    PRODUCT_TYPE = "product_type"
}

/** get property configs for Allocations */
export function getProductPropertyConfigs(): PropertyConfig<PropertyConfigType, PropertyOptionsList | PropertyOptions>[] {
    const i18n = I18nPayment().product;
    return [
        {
            label: i18n.config.name,
            propertyName: keyof<PaymentProduct>("name"),
            typeUid: PropertyConfigType.STRING,
            validators: {
                required: true
            }
        },
        {
            label: i18n.config.defaultPrice,
            propertyName: keyof<PaymentProduct>("price"),
            typeUid: PropertyConfigType.NUMBER
        },
        {
            label: i18n.config.defaultDescription,
            propertyName: keyof<PaymentProduct>("description"),
            typeUid: PropertyConfigType.TEXTAREA
        },
        {
            label: i18n.config.type,
            propertyName: keyof<PaymentProduct>("type"),
            typeUid: PropertyConfigType.LISTSELECT,
            options: {
                itemList: ProductDataSourceUID.PRODUCT_TYPE
            }
        }
    ];
}